<!-- 发布通知 -->
<template>
  <div>
    <m-table
      ref="table"
      :loadObj="{}"
      :dict="[]"
      :option="{}"
      :colObj="{
        opId:304,
        dataClass : 2,
        addBtnClick
      }"
    >
    </m-table>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      firstEnter:true
    };
  },
  computed: {},
  watch: {},
  methods: {
    // 顶部新增
  },
  created() {},
  mounted() {},
  activated() {
    if(this.firstEnter){
      this.firstEnter=false;
    }else{
      this.$refs.table.$refs.child.onLoad();
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
